export class Sol50 {
	//horizontaler Abstand zwischen Modulen in cm
	public static nHorizontalAbstand: number = 0.7;
	//vertikaler Abstand zwischen Modulen in cm
	public static nVertikalAbstand: number = 2.4;
	//Höhe der vertikalen Abschlussblende in cm
	public static nVertikalAbschluss: number = 9.6;
	//Toleranz für Zuschnitt
	public static nZuschnittTol: number = 5;

	public static calcCols(w: number, modul_width: number): number {
		return Math.floor((w + Sol50.nHorizontalAbstand) / (modul_width + Sol50.nHorizontalAbstand));
	}
	/*
	 * Bestimmt, wieviele Quer-Reihen noch möglich sind
	 * h = verfügbare Höhe
	 * */
	public static calcRowsHV(h: number, modheight1: number, modheight2: number, nAnzahlHochReihen: number): number {
		modheight1 += Sol50.nVertikalAbstand;
		modheight2 += Sol50.nVertikalAbstand;
		h -= nAnzahlHochReihen * modheight1;
		return h / modheight2;
	}
	//Bestimmt, wieviele Reihen für die Höhe h bei Modulhöhe modheight möglich sind
	public static calcRowsFromHeight(h: number, modheight: number): number {
		return Math.floor((h + Sol50.nVertikalAbstand) / (modheight + Sol50.nVertikalAbstand));
	}
	public static getAvailHeight(nHeight: number): number {
		return nHeight - Sol50.nVertikalAbschluss * 2;
	}
}